export enum SeriesPaymentState{
  Initial,
  Selected,
  Parsed,
  Checked,
  Paid
}
